// ---------------------------------------------------------------------------
// Variant (filled | outlined | ghost | text | link | default)
// ---------------------------------------------------------------------------

export type ButtonVariant =
  | 'default'
  | 'filled'
  | 'outlined'
  | 'ghost'
  | 'text'
  | 'link';

export enum ButtonVariantEnum {
  DEFAULT = 'default',
  FILLED = 'filled',
  OUTLINED = 'outlined',
  GHOST = 'ghost',
  TEXT = 'text',
  LINK = 'link',
}

// ---------------------------------------------------------------------------
// Severity (colour family)
// ---------------------------------------------------------------------------

export type ButtonSeverity =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'contrast'
  | 'danger'
  | 'success'
  | 'theme';

export enum ButtonSeverityEnum {
  DEFAULT = 'default',
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  CONTRAST = 'contrast',
  DANGER = 'danger',
  SUCCESS = 'success',
  THEME = 'theme',
}

// ---------------------------------------------------------------------------
// Size
// ---------------------------------------------------------------------------

export type ButtonSize = 'xxs' | 'xs' | 'sm' | 'default' | 'lg' | 'xl' | 'xxl';

export enum ButtonSizeEnum {
  XXS = 'xxs',
  XS = 'xs',
  SM = 'sm',
  DEFAULT = 'default',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
}

// ---------------------------------------------------------------------------
// Shape
// ---------------------------------------------------------------------------

export type ButtonShape = 'default' | 'circle' | 'square';

export enum ButtonShapeEnum {
  DEFAULT = 'default',
  CIRCLE = 'circle',
  SQUARE = 'square',
}

// ---------------------------------------------------------------------------
// Icon position
// ---------------------------------------------------------------------------

export type ButtonIconPosition = 'left' | 'right';

export enum ButtonIconPositionEnum {
  LEFT = 'left',
  RIGHT = 'right',
}
